/* eslint-disable no-restricted-imports */
import { useWishLists } from '@/data/Content/WishLists';
import { WishlistWishlistItem } from 'integration/generated/transactions/data-contracts';
import React, { useState } from 'react';
import { AccountFavoriteList } from './AccountFavoriteList';
import { ACCOUNT_FAVORITES_TABS, AccountFavoriteTabs } from './AccountFavoriteTabs';
import { AccountFavoriteSkeleton } from '@/components/content/Account/parts/Skeletons/AccountFavoriteSkeleton';

export const AccountFavorites = () => {
	const [currentTab, setCurrentTab] = useState(ACCOUNT_FAVORITES_TABS.FAVORITES);

	const wishLists = useWishLists();

	const currentWithList =
		currentTab === ACCOUNT_FAVORITES_TABS.FAVORITES
			? wishLists.favoritesWishList
			: wishLists.forLaterWishList;

	if (!wishLists) {
		return <AccountFavoriteSkeleton />;
	}

	return (
		<React.Fragment>
			<AccountFavoriteTabs
				currentTab={currentTab}
				favoriteCount={wishLists?.favoritesWishList?.item?.length || 0}
				forLaterCount={wishLists?.forLaterWishList?.item?.length || 0}
				onTabChange={setCurrentTab}
			/>
			<AccountFavoriteList
				wishLists={currentWithList || ({} as WishlistWishlistItem)}
				onDeleteWishList={wishLists.onDelete}
				onMutateWishLists={wishLists.mutateWishLists}
				listType={currentTab === ACCOUNT_FAVORITES_TABS.FAVORITES ? 'favorites' : 'saved'}
			/>
		</React.Fragment>
	);
};
